import React, { useEffect, useState }  from 'react'
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { breakpoints } from '~styles/global'
import ProductTile from '../ProductTile'
import resolveLink from '~utils/resolveLink'
import { useInView } from 'react-intersection-observer'

const ProductGrid = ({ products, sort }) => {
  
  const { mobile } = breakpoints  

	const [numberShowing, setNumberShowing] = useState(6)
	const [inViewRef, inView] = useInView({threshold: 0,})

	useEffect(() => {
		if (inView) {
			setNumberShowing(numberShowing + 6)
		}
	}, [inView])

	const productsShowing = products?.slice(0, numberShowing)

  return (
    <section
      css={css`
        display: grid;
        grid-template-columns: repeat(12, 1fr);
      `}
    >	
        {productsShowing.map(product => (
					<>
					<ProductTile 
              key={product.id} 
              name={product.title} 
              image={product.content?.image} 
              gif={product.content?.animatedImage} 
              price={Number(product.content?.shopify?.price)}
              link={resolveLink(product._type, product.parent?.slug?.current, product.content.shopify.variantId)} 
              type={product._type}
							video={product.content?.video}
							available={product.content.shopify.inventoryPolicy !== "deny" || product.content.shopify.inventoryQuantity > 0}
          /> 
					{console.log(product)}
					</>
          
        ))}
			{products.length > productsShowing.length &&
				<div ref={inViewRef} style={{height: '100vh'}} />
			}
    </section>
  )
}

ProductGrid.propTypes = {
  productLimit: PropTypes.number,
}

ProductGrid.defaultProps = {
    products: [
        {key:'productkey1', name:'Product 1', image:'',  gif:'', price: 20.00, link:'/'},
        {key:'productkey2', name:'Product 2', image:'',  gif:'', price: "16.95", link:'/'},
        {key:'productkey3', name:'Product 3', image:'',  gif:'', price: "16.95", link:'/'}
    ],
}

export default ProductGrid
